import { createContext, useContext, useState } from "react";

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem("site-language");
    if (saved) return saved;

    const browserLang = navigator.language || navigator.userLanguage;
    return browserLang.startsWith("pt") ? "pt" : "en";
  });

  const changeLanguage = (lang) => {
    setLanguage(lang);
    localStorage.setItem("site-language", lang);
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}